// When true, React is built and served by the API (Insight.Portal.Api) - use same-origin for API calls
const isServedByApi = process.env.REACT_APP_SERVED_BY_API === 'true';

const getBaseUrl = () => {
    var _baseUrl = '/';
    var _isProdution = document.location.host.indexOf('insightresults.com') !== -1;
    // HashRouter: URL is origin/#/Home - pathname is always /, route is in hash
    if (_isProdution && !window.location.hash) {
        const pathPart = window.location.pathname.split('/').filter(Boolean)[0];
        if (pathPart && pathPart !== 'index.html') {
            _baseUrl = '/' + pathPart + '/';
        }
    }
    return _baseUrl;
};

const getAppBaseUrl = () => {
    var _baseUrl = '/';
    var _isProdution = document.location.host.indexOf('insightresults.com') !== -1;
    // HashRouter: use origin for base
    if (_isProdution && !window.location.hash) {
        const pathPart = window.location.pathname.split('/').filter(Boolean)[0];
        if (pathPart && pathPart !== 'index.html') {
            _baseUrl = '/' + pathPart + '/';
        }
    }
    if (!_isProdution) {
        _baseUrl = window.location.protocol + '//' + window.location.host
    }
    return _baseUrl;
};
const getApiUrl = () => {
    return `${window.location.protocol}//${window.location.host}/api/`;
}

// Auth0 configuration - set in environment or use defaults for dev
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

const AppConfig = {
    auth0: {
        domain: auth0Domain,
        clientId: auth0ClientId,
        audience: auth0Audience,
        useAuth0: !!(auth0Domain && auth0ClientId),
    },
    appMode: ['portal', 'portal2', 'portalqa', 'portalapi'].includes(window.location.host.replace('.insightresults.com', '')) ? 'prod' : 'dev',
    env: function (config) {
        if (this.appMode === 'prod') {
            return this.prod[config];
        }
        else {
            return this.dev[config];
        }
    },
    textAutoSaveDelay: 4000, //in miliseconds
    modifiedOnDateFormat: 'LLL',
    baseUrl: getBaseUrl(),
    appBaseUrl: getAppBaseUrl(),
    reduxLogger: false,
    axiosLogger: false,

    dev: {
        deviceType: 'desktop', // 'desktop', 'mobile'
        url: isServedByApi ? 'api/' : 'http://localhost:5012/api/',
        userId: '007ac369-51d2-4155-9c8c-c51db774ab59', //localStorage.getItem('userId'), //'67A179E0-714F-4BBD-94F7-54128DF86893',//Ankit '4DE36305-AD07-4BAE-A846-88D6BA36D7D6',//akhilesh '007ac369-51d2-4155-9c8c-c51db774ab59',
        connectionId: '',
        taskUrl: 'http://localhost:51327/'
    },
    prod: {
        deviceType: 'desktop',
        url: isServedByApi ? 'api/' : 'https://portalapi.insightresults.com/',
        userId: '',
        connectionId: '',
        taskUrl: 'http://tasks.insightresults.com/'
    }
}

export default AppConfig;
